import React from 'react';

export function Footer(props) {
	return (
      <div style={{textAlign: 'center'}}>
        <hr style={{marginTop: '10px'}}/>
        <p>
          Contact <a href="mailto:admin@jazz-vocalists.uk">admin@jazz-vocalists.uk</a> for additions or corrections<br/>
          <small>&copy; 2026 Richard Cook</small>
        </p>
      </div>
	);
} 